export default "__VITE_ASSET__08921c1c__"